import styled from "styled-components";
import {motion} from "framer-motion";

export const StyledTabbedList = styled(motion.div)`

`;